<template>
  <div class="modalLink">
    <div style="border-radius:10px;padding:10px;" class="card">
      <h3 style="font-size:14px;">{{ $t("insight.linkToShare") }}</h3>
      <hr />
      <div
        v-clipboard:copy="
          lienParticipants +
            '/?insight=' +
            this.insight_en_cours.name.replace(/ /g, '+')
        "
        v-clipboard:success="onCopy"
        class="hover-download-button button"
      >
        {{ $t("insight.copyLink") }}
      </div>
      <br />
      <div class="small-text mt-5">
        <a target="_blank" @click="$parent.close()" :href="lienParticipants">{{
          $t("insight.clickHere")
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["lienParticipants"],
  computed: {
    ...mapGetters(["insight_en_cours"]),
  },
  methods: {
    onCopy() {
      this.$buefy.toast.open({
        type: "is-success",
        position: "is-top",
        message: this.$i18n.t("toast.copie.OK"),
      });
    },
  },
};
</script>
<style scoped>
.hover-download-button {
  padding: 8px;
  border-radius: 0px;
  font-size: 12px;
  color: white;
  background-color: #424a60;
}
.hover-download-button:hover {
  background-color: #424a60;
  color: white;
}
.modalLink {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>
